import { Group } from 'three';
import { EEntityType } from '../types';
import BaseEntity from './BaseEntity';
import { getUniqueId } from '../utils';
import { ENTITY_PRIORITY } from '../constant/entity';
import { EContainerType } from '../types/entity';
import { globalStores } from '../stores';
import { modelManager } from '../manager/entityManager';
import FurnitureEntity from './furnitureEntity';
import { IModelGroupData } from '../data/modelGroup/modelGroup';

class ModelGroupEntity extends BaseEntity<EEntityType.ModelGroup> {
  protected _modelGroup: Group = new Group();
  private _entityId: string;
  private _accessorieIds: string[];

  constructor(params?: { id: string }) {
    super();

    const id = params?.id || getUniqueId();
    this._entityId = id;
    this._id = id;
    this._accessorieIds = [];

    this._modelGroup.userData.type = EEntityType.ModelGroup;
    this._modelGroup.userData.priority = ENTITY_PRIORITY.modelGroup;
    this._modelGroup.userData.entityId = id;
    this._modelGroup.userData.containerType = EContainerType.entity;
  }

  get group() {
    return this._modelGroup;
  }

  get entityId() {
    return this._entityId;
  }

  get accessorieIds() {
    return this._accessorieIds;
  }

  override update(modelGroupData: IModelGroupData) {
    this._accessorieIds = modelGroupData.accessorieIds;
    for (const accessorieId of modelGroupData.accessorieIds) {
      const furnitureData = globalStores.modelStore.getFurnitureData(accessorieId);
      if (furnitureData) {
        const entity = modelManager.furnitureManager.getEntity(accessorieId);
        if (entity) {
          entity.update(furnitureData);
        } else {
          const newEntity = new FurnitureEntity({
            id: accessorieId,
            visible: true
          });
          newEntity.update(furnitureData);
        }
      }
    }
  }
}

export default ModelGroupEntity;
